export interface Message {
    id: number
    content: string
    role: ChatMessageRoleType
    timestamp: Date
}

export enum ChatMessageRoleType {
    USER = "user",
    ASSISTANT = "assistant",
    SYSTEM = "system",
}

export interface FileMessage {
    id: string
    name: string
}
